import { Printer } from "lucide-react";
import { useCentro } from "@/lib/centro";

export const PrintButton = ({ label = "Imprimir listado" }) => (
  <button type="button" onClick={() => window.print()} data-testid="print-list-btn"
    className="no-print inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors">
    <Printer className="h-4 w-4" />{label}
  </button>
);

export const PrintHeader = ({ title, detalle, n }) => {
  const { centro } = useCentro();
  return (
    <div className="print-only mb-3 border-b-2 border-slate-800 pb-2" data-testid="print-header">
      <div className="flex justify-between items-end">
        <div className="text-lg font-bold">Salud y Visión · {title}</div>
        <div className="text-xs">{new Date().toLocaleDateString("es-ES")}</div>
      </div>
      <div className="text-xs text-slate-600">{[detalle, centro ? `Centro ${centro}` : "Todos los centros", n != null ? `${n} registros` : ""].filter(Boolean).join(" · ")}</div>
    </div>
  );
};
